export default __webpack_public_path__ + "static/media/noResultsDistributions.863f67d1.svg";